<ng-container *ngIf="!villaPriceAnalysisLoading">
    <app-price-analysis-property
    *ngIf="villaPriceGraphData"
    [dropdownLabel]="'reports.pleaseSelectZoning'"
    [SectionId]="chartId"
    [graphData]="villaPriceGraphData"
    [chartTitle]="title"
    [reportType]="'price'"
    [showDropdown]="false"
    ></app-price-analysis-property>
</ng-container>